import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import baseURL from '../../config/api';
import { formatUSPhone } from '../../utils/phoneFormatter';
import Cookies from 'js-cookie';

const FamilyMember = () => {
  const token = Cookies.get("token-my-cdir");
  const { id, name }: any = useParams();
  const [memberData, setMemberData] = useState<any[]>([]);
  const [memberDataIsLoaded, setMemberDataIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (id) {
      fetch(`${baseURL}FamilyMember/GetFamilyMemberByMemberId/${parseInt(id)}`, {
        headers: {
          Authorization: `Bearer ${token?.toString()}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          setMemberData(
            data.map((item: any) => {
              return {
                id: item.id,
                name: item.firstName + " " + item.lastName,
                address: `${item?.street}, ${item?.street2} ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                phoneNumber: item.phoneNumber,
                emailAddress: item.emailAddress,
                imagePath:
                  item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                    "./images/user-default.jpg"
              }
            })
          )
          setMemberDataIsLoaded(true);
        })
        .catch(error => console.log(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <section className="min-h-screen">
      <div className="py-6 px-4 mx-auto max-w-screen-xl lg:py-10 lg:px-6">
        <div className="mx-auto max-w-screen-md text-center mb-10">
          <h2 className="text-4xl font-bold tracking-tight bg-gradient-to-r from-secondary to-secondary/80 bg-clip-text text-transparent">
            {name}
          </h2>

          <p className="mt-2 text-gray-500 text-lg">
            {memberData.length > 0
              ? "Family Members"
              : "No Family Member Added"}
          </p>
        </div>

        {memberDataIsLoaded ? (
          memberData.length > 0 ? (
            <div className="grid gap-6 xm:grid-cols-2 lg:grid-cols-3">
              {memberData.map((item, index) => (
                <div
                  key={index}
                  className="group relative bg-white/70 backdrop-blur-lg border border-gray-200 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                  <div className="h-20 bg-gradient-to-r from-secondary to-secondary/80" />

                  <div className="flex flex-col items-center px-6 pb-6 -mt-12">
                    <div className="w-24 h-24 rounded-full border-4 border-white shadow-md overflow-hidden">
                      <img
                        src={item.imagePath}
                        alt="family"
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = "/images/user-default.jpg";
                        }}
                      />
                    </div>

                    <h3 className="mt-4 text-lg font-semibold text-gray-800 text-center break-words">
                      {item.name}
                    </h3>

                    <div className="mt-4 w-full bg-gray-50 rounded-xl p-3 space-y-2 border border-gray-100">

                      <div className="flex items-center gap-2 text-gray-700">
                        <BsFillTelephoneFill size={14} />
                        <span className="text-sm font-medium truncate">
                          {formatUSPhone(item?.phoneNumber || "")}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 text-gray-700">
                        <MdEmail size={14} />
                        <span className="text-sm font-medium truncate">
                          {item.emailAddress}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-[250px] flex flex-col justify-center items-center text-gray-500">
              <p className="text-lg font-medium">No Members Found</p>
              <p className="text-sm text-gray-400">
                Try adding family members
              </p>
            </div>
          )
        ) : (
          <div className="flex flex-col justify-center items-center h-[300px] gap-3">
            <div className="h-10 w-10 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-600 font-medium">
              Loading members...
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

export default FamilyMember